import InfoAlertIcon from '@icons/InfoAlertIcon';
import { cn } from '@lib/utils';

interface DetailsItemProps {
  value: string;
  label: string;
  error?: string;
}

export const DetailsItem = ({ value, label, error }: DetailsItemProps) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-[6px] px-2 py-[0.375rem] text-xs leading-[0.5rem] text-neutral03/50',
        { 'rounded-xl bg-[#6E0C1D4D] pt-2 text-meaning-alert': error },
      )}
    >
      <div className="flex items-center gap-[0.375rem]">
        <span>{label}</span>
        <div
          className={cn(
            'mt-auto flex-1 border-b-[1px] border-dashed border-b-neutral06',
            { 'border-meaning-alert opacity-30': error },
          )}
        />
        <div>
          <span>{value}</span>
        </div>
      </div>
      {error && (
        <div className="flex w-full items-center justify-between opacity-60">
          <span>{error}</span>
          <InfoAlertIcon className="h-4 w-4" />
        </div>
      )}
    </div>
  );
};

interface Props {
  currentBalance: string;
  annualPrice?: string;
  monthlyPrice?: string;
  nextBillingDate: string;
  remainingBalance?: string;
  insufficientFunds?: string;
}

export const Details = ({
  annualPrice,
  currentBalance,
  monthlyPrice,
  nextBillingDate,
  remainingBalance,
  insufficientFunds,
}: Props) => {
  return (
    <div className="flex flex-col gap-1 rounded-[0.625rem] rounded-t-none border-2 border-t-0 border-card-stroke/20 px-2 py-4 font-medium">
      <DetailsItem label="Current balance" value={currentBalance} />
      {insufficientFunds && (
        <DetailsItem
          label="Insufficient funds"
          value={insufficientFunds}
          error="Switch account or top up your balance"
        />
      )}
      {annualPrice && (
        <DetailsItem
          label="Cost of the plan for 12 months"
          value={annualPrice}
        />
      )}
      {monthlyPrice && (
        <DetailsItem
          label="Cost of the plan for 1 month"
          value={monthlyPrice}
        />
      )}
      {!insufficientFunds && (
        <DetailsItem label="Remaining balance" value={remainingBalance ?? ''} />
      )}
      <DetailsItem label="Next billing date" value={nextBillingDate} />
    </div>
  );
};
